import { Card } from "@portal/BaseComponents/Card/AntCard";
import { Style } from "@portal/lib/style/style";

export const TilesContainer = Style(Card, {
  "&.ant-card ": {
    border: 0,
    paddingInline: "120px",
    borderRadius: 0,
  },
  ".ant-card-body": {
    padding: "32px 0 var(--space-24) 0",
  },
});

export const TileWrapper = Style("div", {
  display: "grid",
  gap: "var(--space-12)",
  variants: {
    layout: {
      l1: {
        gridTemplateColumns: "repeat(2, auto)",
      },
      l2: {
        gridTemplateColumns: "repeat(3, auto)",
      },
    },
  },
});
